// White-labelled colleges whose students sign in on their own host. On logout
// (or a lost session) they are sent back to that login instead of rizee.in.
// Add a college here: institution_id -> its login page.
const BRAND_LOGIN_URLS = {
  119: "https://vignan.rizee.in/login",
  100: "https://sowdambikaa.rizee.in/login",
};

// The branded login for an institution id (cookie value or number), or "" when
// the institution uses the standard Rizee login.
export const brandLoginUrl = (institutionId) =>
  BRAND_LOGIN_URLS[parseInt(institutionId, 10)] || "";
